import { useState } from 'react';
import { UserPlus } from 'lucide-react';
import { UserTable } from '../components/admin/UserTable';
import { UserEditDrawer } from '../components/admin/UserEditDrawer';
import { InviteUserModal } from '../components/admin/InviteUserModal';
import type { AdminUser } from '../services/adminApi';

export function AdminUsers() {
  const [selectedUser, setSelectedUser] = useState<AdminUser | null>(null);
  const [inviteOpen, setInviteOpen] = useState(false);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-lg font-bold text-ems-text-primary">User Management</h1>
          <p className="text-sm text-ems-text-muted">Manage users and site access permissions</p>
        </div>
        <button
          onClick={() => setInviteOpen(true)}
          className="flex items-center gap-2 px-4 py-2 rounded-lg bg-ems-forest text-ems-green border border-ems-green/20 text-sm font-medium hover:bg-ems-forest/80 transition-colors"
        >
          <UserPlus className="w-4 h-4" />
          Invite User
        </button>
      </div>

      <UserTable onSelectUser={setSelectedUser} />
      <UserEditDrawer user={selectedUser} onClose={() => setSelectedUser(null)} />
      <InviteUserModal open={inviteOpen} onClose={() => setInviteOpen(false)} />
    </div>
  );
}
